import getIsAdmin from '@package/utils/src/getIsAdmin';
import configs from 'config-base';

import { useStrictQuery } from '../useCustomQuery';

import { ALLERT_EDIT_QUERY_KEY } from './types';

const webAdminDomainUrl = configs.webAdminUrl;

export default function useAllertEdit(id: string, allertType: string) {
  const { data: allertEditUrl = '' } = useStrictQuery(
    [ALLERT_EDIT_QUERY_KEY],
    async () => {
      const isAdmin = await getIsAdmin();
      if (!isAdmin) return null;
      let data: string = '';
      if (webAdminDomainUrl) {
        data = `${webAdminDomainUrl}${allertType}.php?id=${id}`;
      }
      return data;
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );

  return { allertEditUrl };
}
